// extracted by mini-css-extract-plugin
export default {"container":"LineAnimation_container__6fBY3","animationSVG":"LineAnimation_animationSVG__j6qV1"};